import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsWhichProducesResourceIdAvailable } from "../selectors/selectBuildingsWhichProducesResourceIdAvailable";
import { createPathFocusBuildingMaxLevel } from "./createPathFocusBuildingMaxLevel";
export var pathFocusBuildingConstructionDoneProductionDoneMaxLevel = function (action, state$, deps) {
    return createPathFocusBuildingMaxLevel(function () {
        var state = state$.value;
        var availableBuildings = selectBuildingsWhichProducesResourceIdAvailable(state, action.taskType.resourceId);
        return availableBuildings.filter(function (building) {
            return utilBuildings.hasFinishedProduction(building) ||
                utilBuildings.hasFinishedConstruction(building);
        });
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathFocusBuildingConstructionDoneProductionDoneMaxLevel.ts
// module id = 897
// module chunks = 3